import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import CreatorSchedule from '@/components/creator_schedule.vue'
import WorkHistory from '@/components/work_history.vue'
import VueElementLoading from 'vue-element-loading'

export default class extends Controller {
  static targets = ['schedule']

  connect() {
    const app = createApp(CreatorSchedule, {
      creator: JSON.parse(this.element.dataset.creator),
      creatorSelectable: JSON.parse(
        this.element.dataset.creatorSelectable?.toLowerCase()
      ),
      shiftOptions: JSON.parse(this.element.dataset.shiftOptions),
      month: this.element.dataset.month
    })
    app.use(PrimeVue, {
      locale: {
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ]
      }
    })
    app.component('WorkHistory', WorkHistory)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.scheduleTarget)
  }
}
